module.exports = __webpack_public_path__ + "img/Upper Body-Recommend.6fe7a38.png";